import { apiSlice, publicApiSlice } from "@app/apiSlice";
import { createDropdownOptionsApi } from "./createDropdownOptionsApi";
// Create both private and public API slices
export const dropdownOptionsApiSlice = createDropdownOptionsApi(apiSlice);
export const publicDropdownOptionsApiSlice = createDropdownOptionsApi(publicApiSlice);

// Export hooks for private API
export const {
	useGetLandUseTypesQuery,
	useGetLandUseTypeByIdQuery,
	useGetTypesOfFisheryQuery,
	useGetFishCategoriesQuery,
	useGetLargeFishGearCategoriesQuery,
	useGetSmallFishGearCategoryQuery,
	useGetCropTypesQuery,
	useGetOrganicInputTypesQuery,
	useGetResidueTypesQuery,
	useGetTillageTypesQuery,
	useGetGrasslandTypesQuery,
	useGetGWPSourcesQuery,
	useGetGWPByIdQuery,
	useGetCountriesQuery,
	useGetCountryByIdQuery,
	useLazyGetCountryByIdQuery,
	useGetClimateTypesQuery,
	useGetClimateByIdQuery,
	useGetMoistureTypesQuery,
	useGetMoistureByIdQuery,
	useGetSoilTypesQuery,
	useGetSoilTypeByIdQuery,
	useGetProjectStatusesQuery,
	useGetStatusByIdQuery,
	useCreateExecutingAgencyMutation,
	useCreateFundingAgencyMutation,
	useGetExecutingAgenciesQuery,
	useGetFundingAgenciesQuery,
	useGetForestTypesQuery,
	useGetForestConditionTypesQuery,
	useGetTrophicTypesQuery,
	useGetWaterbodyTypesQuery,
	useGetMacroFuelTypesQuery,
	useGetMacroFuelTypeByIdQuery,
	useGetFuelTypesQuery,
	// useGetFuelTypeByIdQuery,
	useGetFuelUseTypesQuery,
	useGetFuelUseTypeByIdQuery,
	useGetIrrigationSystemTypesQuery,
	useGetSettlementTypesQuery,
	useGetChangeRatesQuery,
	useGetRefrigerantTypesQuery,
	useGetPackagingMaterialTypesQuery,
	useGetInputTypesQuery,
	useGetInputTypeByIdQuery,
	useGetMacroInputTypesQuery,
	useGetMacroInputTypeByIdQuery,
	useGetStatusTypesQuery,
	endpoints,
} = dropdownOptionsApiSlice;

// Export hooks for public API - only read operations
export const {
	useGetLandUseTypesQuery: usePublicGetLandUseTypesQuery,
	useGetLandUseTypeByIdQuery: usePublicGetLandUseTypeByIdQuery,
	useGetTypesOfFisheryQuery: usePublicGetTypesOfFisheryQuery,
	useGetFishCategoriesQuery: usePublicGetFishCategoriesQuery,
	useGetLargeFishGearCategoriesQuery: usePublicGetLargeFishGearCategoriesQuery,
	useGetSmallFishGearCategoryQuery: usePublicGetSmallFishGearCategoryQuery,
	useGetCropTypesQuery: usePublicGetCropTypesQuery,
	useGetOrganicInputTypesQuery: usePublicGetOrganicInputTypesQuery,
	useGetResidueTypesQuery: usePublicGetResidueTypesQuery,
	useGetTillageTypesQuery: usePublicGetTillageTypesQuery,
	useGetGrasslandTypesQuery: usePublicGetGrasslandTypesQuery,
	useGetGWPSourcesQuery: usePublicGetGWPSourcesQuery,
	useGetGWPByIdQuery: usePublicGetGWPByIdQuery,
	useGetCountriesQuery: usePublicGetCountriesQuery,
	useGetCountryByIdQuery: usePublicGetCountryByIdQuery,
	useLazyGetCountryByIdQuery: useLazyPublicGetCountryByIdQuery,
	useGetClimateTypesQuery: usePublicGetClimateTypesQuery,
	useGetClimateByIdQuery: usePublicGetClimateByIdQuery,
	useGetMoistureTypesQuery: usePublicGetMoistureTypesQuery,
	useGetMoistureByIdQuery: usePublicGetMoistureByIdQuery,
	useGetSoilTypesQuery: usePublicGetSoilTypesQuery,
	useGetSoilTypeByIdQuery: usePublicGetSoilTypeByIdQuery,
	useGetProjectStatusesQuery: usePublicGetProjectStatusesQuery,
	useGetStatusByIdQuery: usePublicGetStatusByIdQuery,
	useGetExecutingAgenciesQuery: usePublicGetExecutingAgenciesQuery,
	useGetFundingAgenciesQuery: usePublicGetFundingAgenciesQuery,
	useGetForestTypesQuery: usePublicGetForestTypesQuery,
	useGetForestConditionTypesQuery: usePublicGetForestConditionTypesQuery,
	useGetTrophicTypesQuery: usePublicGetTrophicTypesQuery,
	useGetWaterbodyTypesQuery: usePublicGetWaterbodyTypesQuery,
	useGetMacroFuelTypesQuery: usePublicGetMacroFuelTypesQuery,
	useGetMacroFuelTypeByIdQuery: usePublicGetMacroFuelTypeByIdQuery,
	useGetFuelTypesQuery: usePublicGetFuelTypesQuery,
	// useGetFuelTypeByIdQuery: usePublicGetFuelTypeByIdQuery,
	useGetFuelUseTypesQuery: usePublicGetFuelUseTypesQuery,
	useGetFuelUseTypeByIdQuery: usePublicGetFuelUseTypeByIdQuery,
	useGetIrrigationSystemTypesQuery: usePublicGetIrrigationSystemTypesQuery,
	useGetSettlementTypesQuery: usePublicGetSettlementTypesQuery,
	useGetChangeRatesQuery: usePublicGetChangeRatesQuery,
	useGetRefrigerantTypesQuery: usePublicGetRefrigerantTypesQuery,
	useGetPackagingMaterialTypesQuery: usePublicGetPackagingMaterialTypesQuery,
	useGetInputTypesQuery: usePublicGetInputTypesQuery,
	useGetInputTypeByIdQuery: usePublicGetInputTypeByIdQuery,
	useGetMacroInputTypesQuery: usePublicGetMacroInputTypesQuery,
	useGetMacroInputTypeByIdQuery: usePublicGetMacroInputTypeByIdQuery,
	useGetStatusTypesQuery: usePublicGetStatusTypesQuery,
} = publicDropdownOptionsApiSlice;